export default {
    namespaced: true,

    state: () => {
        return {
            loading: false,
            buildings: [],
        }
    },

    getters: {
        loading(state) {
            return state.loading;
        },

        buildings(state) {
            return state.buildings.map((item, sl) => {
                item.sl = sl + 1;
                return item;
            });
        }
    },

    mutations: {
        setLoading(state, loading) {
            state.loading = loading
        },

        setBuilding(state, buildings) {
            state.buildings = buildings
        },
    },

    actions: {
        async getBuildings(context) {
            context.commit('setLoading', true);
        
            await axios.get(`${this.state.host}/get-buildings`, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                context.commit('setBuilding', res.data.buildings);
            })
            .catch(error => this.dispatch('snackbar/error', error))

            context.commit('setLoading', false);
        },

        async saveBuilding(context, payload) {
            let isSuccess = false;

            let url = '';
            if(payload.id != null) {
                url = 'update-building';
            } else {
                url = 'add-building';
                delete payload.id
            }

            await axios.post(`${this.state.host}/${url}`, payload, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                isSuccess = true;
                this.dispatch('snackbar/success', res.data.message);
                context.dispatch('getBuildings');
            })
            .catch(error => { 
                isSuccess = false;
                this.dispatch('snackbar/error', error);
            })

            return isSuccess;
        },

        async deleteBuilding(context, id) {
            let isSuccess = false;

            await axios.delete(`${this.state.host}/delete-building/${id}`, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                isSuccess = true;
                this.dispatch('snackbar/success', res.data.message);
                context.dispatch('getBuildings');
            })
            .catch(error => { 
                isSuccess = false;
                this.dispatch('snackbar/error', error);
            })

            return isSuccess;
        }
    }
}
